import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Feedback contact phones arrive as "+<country code><number>" for any
 * country. Items from older app builds hold just the 10-digit Indian
 * mobile, which is read as +91.
 */
export function formatPhone(stored: string): { display: string; tel: string } {
  const e164 = stored.startsWith("+")
    ? stored
    : /^[6-9]\d{9}$/.test(stored)
      ? `+91${stored}`
      : `+${stored}`;
  const phone = parsePhoneNumberFromString(e164);
  if (!phone || !phone.isPossible()) return { display: e164, tel: e164 };
  return { display: phone.formatInternational(), tel: phone.number };
}
